import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { MsisdnProcedureInterface } from '../models/msisdn-procedure.interface';
import { LineInterface } from '../models/line.interface';

@Injectable()
export class MsisdnProcedureService {

  constructor(private apiService: ApiService) {}

  /**
   * Get procedures list
   */
  get(line: LineInterface): Observable<Array<MsisdnProcedureInterface>> {
    const body = {
        phoneNumber: line.phoneNumber
    };
    return this.apiService.post('msisdn/procedures/list', body);
  }
}
